import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteData,
  type DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteError,
  type DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteResponse,
  deletePdpV1PortfoliosPortfolioIdPdpsPdpIdDelete,
} from '../../generated';

export type DeletePdpMutationVariables = DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteData['path'];

export type DeletePdpMutation = DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteResponse;

export const useDeletePdpMutation = <TError = DeletePdpV1PortfoliosPortfolioIdPdpsPdpIdDeleteError, TContext = unknown>(
  options?: Omit<
    UseMutationOptions<DeletePdpMutation, TError, DeletePdpMutationVariables, TContext>,
    'mutationKey' | 'mutationFn'
  >,
) => {
  return useMutation<DeletePdpMutation, TError, DeletePdpMutationVariables, TContext>({
    mutationKey: ['DeletePdp'],
    mutationFn: async ({ portfolio_id, pdp_id }: DeletePdpMutationVariables) => {
      const { data } = await deletePdpV1PortfoliosPortfolioIdPdpsPdpIdDelete({
        path: { portfolio_id, pdp_id },
        throwOnError: true,
      });
      return data;
    },
    ...options,
  });
};

useDeletePdpMutation.fetcher = (
  { portfolio_id, pdp_id }: DeletePdpMutationVariables,
  _headers?: RequestInit['headers'],
) => {
  return async () => {
    const { data } = await deletePdpV1PortfoliosPortfolioIdPdpsPdpIdDelete({
      path: { portfolio_id, pdp_id },
      throwOnError: true,
    });
    return data;
  };
};
